/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './template-front-shared.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../../app/front/templates-front/template-front-shared/template-front-shared.component';
import * as i4 from '../../../../../app/front/front.service';
import * as i5 from '../../../../../app/services/master.service';
import * as i6 from '../../../../../app/services/template.service';
const styles_TemplateFrontSharedComponent:any[] = [i0.styles];
export const RenderType_TemplateFrontSharedComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TemplateFrontSharedComponent,data:{}});
export function View_TemplateFrontSharedComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{newTemplate:0}),i1.ɵqud(402653184,2,{newTemplateModalClose:0}),
      i1.ɵqud(402653184,3,{previewModal:0}),(_l()(),i1.ɵeld(3,16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(4,212992,(null as any),
          0,i2.RouterOutlet,[i2.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,
              [8,(null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export function View_TemplateFrontSharedComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-template-front-shared',
      ([] as any[]),(null as any),(null as any),(null as any),View_TemplateFrontSharedComponent_0,
      RenderType_TemplateFrontSharedComponent)),i1.ɵdid(1,245760,(null as any),0,i3.TemplateFrontSharedComponent,
      [i4.FrontService,i5.MasterService,i6.TemplateService,i2.ActivatedRoute,i2.Router],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TemplateFrontSharedComponentNgFactory:i1.ComponentFactory<i3.TemplateFrontSharedComponent> = i1.ɵccf('app-template-front-shared',
    i3.TemplateFrontSharedComponent,View_TemplateFrontSharedComponent_Host_0,{},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGUtZnJvbnQtc2hhcmVkL3RlbXBsYXRlLWZyb250LXNoYXJlZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L3RlbXBsYXRlcy1mcm9udC90ZW1wbGF0ZS1mcm9udC1zaGFyZWQvdGVtcGxhdGUtZnJvbnQtc2hhcmVkLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGUtZnJvbnQtc2hhcmVkL3RlbXBsYXRlLWZyb250LXNoYXJlZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGUtZnJvbnQtc2hhcmVkL3RlbXBsYXRlLWZyb250LXNoYXJlZC5jb21wb25lbnQudHMuVGVtcGxhdGVGcm9udFNoYXJlZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbiIsIjxhcHAtdGVtcGxhdGUtZnJvbnQtc2hhcmVkPjwvYXBwLXRlbXBsYXRlLWZyb250LXNoYXJlZD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs0Q0NBQTtVQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBO01BQStCO0lBQS9COzs7O29CQ0FBO01BQUE7NkNBQUEsVUFBQTtNQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/templates-front/template-front-shared/template-front-shared.component.ngfactory.ts